import { Component, inject } from '@angular/core';
import { I18nService } from '../../services/i18n.service';

@Component({
  selector: 'app-us-ca-privacy-rights',
  imports: [],
  templateUrl: './us-ca-privacy-rights.html',
  styleUrl: './us-ca-privacy-rights.scss',
})
export class UsCaPrivacyRightsComponent {
  public i18n = inject(I18nService);
}
